import _Loading from "@kibt/meta-ui/es/loading";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import _regeneratorRuntime from "/media/disk1/fordata/jenkins/rbdNodeJs/workspace/SRC/node_modules/@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import yoda from '@ks/yoda-js-sdk';
import { defineComponent, nextTick, onMounted, ref } from '@vue/composition-api';
import { handleError } from '@/utils/handle-error';
import { logger } from '@/utils/logger';
import Top100 from './top100.vue';
import { getScrollPhoto, getTop100HomeData } from './services';
import End from './components/end.vue';
import { sendTop100CustomLog } from '@/utils/custom-log';
import { getBucket, kpn } from '@/utils/device';
import { addShareParams } from '@/utils/share';
import { isInApp } from '@/utils/yoda';
export default defineComponent({
  components: {
    MLoading: _Loading,
    Top100: Top100,
    End: End
  },
  setup: function setup() {
    var handleClose = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return yoda.ready();

              case 2:
                yoda.webview.backOrClose();

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function handleClose() {
        return _ref.apply(this, arguments);
      };
    }();

    var loading = ref(false);
    var data = ref(null);
    var dateTime = new Date().getTime();
    var isEnding = ref(false);

    var initData = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var ret;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                loading.value = true;
                _context2.next = 3;
                return getTop100HomeData();

              case 3:
                ret = _context2.sent;
                loading.value = false; // 其他桶或者是结束了

                if (!(ret.result === 139604000 || ret.data && ret.data.part4Time <= dateTime)) {
                  _context2.next = 9;
                  break;
                }

                isEnding.value = true;
                _context2.next = 17;
                break;

              case 9:
                if (!(ret.result === 1)) {
                  _context2.next = 14;
                  break;
                }

                data.value = ret.data; // 如果在阶段2和阶段4之间，就请求选手

                if (data.value.part3Time >= dateTime) {
                  fetchScrollPhotoData();
                }

                _context2.next = 17;
                break;

              case 14:
                _context2.next = 16;
                return handleError({
                  result: ret.result,
                  error_message: 'Erro de internet, tente novamente mais tarde'
                }, true);

              case 16:
                initData();

              case 17:
                _context2.next = 19;
                return nextTick();

              case 19:
                logger.fmp();

              case 20:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function initData() {
        return _ref2.apply(this, arguments);
      };
    }();

    var photoList = ref([]);
    var isFetchingScroll = false;

    var fetchScrollPhotoData = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var ret;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!isFetchingScroll) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt("return");

              case 2:
                isFetchingScroll = true;
                _context3.next = 5;
                return getScrollPhoto();

              case 5:
                ret = _context3.sent;
                isFetchingScroll = false;

                if (ret.result === 1 && ret.data.length > 0) {
                  photoList.value = ret.data;
                }

              case 8:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function fetchScrollPhotoData() {
        return _ref3.apply(this, arguments);
      };
    }();

    onMounted(function () {
      initData();
      logger.kwailog.sendPv({
        page: 'TOP_100'
      });
    });
    var isFetchingPlayers = false;

    var handleChangePlayers = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var ret;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!isFetchingPlayers) {
                  _context4.next = 2;
                  break;
                }

                return _context4.abrupt("return");

              case 2:
                isFetchingPlayers = true;
                _context4.next = 5;
                return getTop100HomeData();

              case 5:
                ret = _context4.sent;
                isFetchingPlayers = false;

                if (ret.result === 1 && data.value && ret.data && ret.data.displayedUsers && ret.data.displayedUsers.length > 0) {
                  data.value = _objectSpread(_objectSpread({}, data.value), {}, {
                    displayedUsers: ret.data.displayedUsers
                  });
                }

              case 8:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      return function handleChangePlayers() {
        return _ref4.apply(this, arguments);
      };
    }();

    var handleShare = /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var url;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                sendTop100CustomLog({
                  event: 'clickToShare'
                });
                url = new URL("".concat(window.location.origin, "/creator/top100"));
                url.searchParams.set('kpn', kpn);
                url.searchParams.set('source', 'SHARE');
                url.searchParams.set('bizId', 'hideBar');
                url.searchParams.set('hyId', 'creator_top');
                url.searchParams.set('bucket', getBucket());
                addShareParams(url, 'creator_top100');
                _context5.next = 10;
                return yoda.ready();

              case 10:
                _context5.next = 12;
                return yoda.component.selectShare({
                  param: {
                    type: 'link',
                    siteUrl: url.href,
                    needShorten: true,
                    caption: 'KWAI TOP 100'
                  }
                });

              case 12:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      return function handleShare() {
        return _ref5.apply(this, arguments);
      };
    }();

    return {
      handleClose: handleClose,
      loading: loading,
      data: data,
      photoList: photoList,
      fetchScrollPhotoData: fetchScrollPhotoData,
      handleChangePlayers: handleChangePlayers,
      dateTime: dateTime,
      handleShare: handleShare,
      isInApp: isInApp,
      isEnding: isEnding
    };
  }
});